// extracted by mini-css-extract-plugin
export default {"projects-wrapper":"support_projects-wrapper__JbRw9","projects-title-wrapper":"support_projects-title-wrapper__XgL4w","impersonate-button":"support_impersonate-button__QZ5Cg"};